import { render, staticRenderFns } from "./LPUserCarouselArrow.vue?vue&type=template&id=742a28c6&scoped=true"
import script from "./LPUserCarouselArrow.vue?vue&type=script&lang=ts"
export * from "./LPUserCarouselArrow.vue?vue&type=script&lang=ts"
import style0 from "./LPUserCarouselArrow.vue?vue&type=style&index=0&id=742a28c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742a28c6",
  null
  
)

export default component.exports